import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx";
import { ChevronsUpDown, GalleryVerticalEnd } from "lucide-react";
import { useAppConfig } from "@/dataProviders/ConfigDataProvider.tsx";
import { useMemo } from "react";
import { cn } from "@/lib/utils.ts";

interface Props {
  className?: string;
}

export function AppSwitch({ className }: Props) {
  const { isMobile } = useSidebar();
  const { apps, activeApp, setActiveApp } = useAppConfig();

  const activeAppName = useMemo(() => {
    return apps.find((app) => app.code === activeApp);
  }, [activeApp, apps]);

  if (!activeApp.length) {
    return null;
  }

  return (
    <SidebarMenu className={cn(className, "bg-sidebar-accent rounded-lg")}>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                <GalleryVerticalEnd className={"size-5"} />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">{activeAppName?.name}</span>
              </div>
              <ChevronsUpDown className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-xs text-muted-foreground">Apps</DropdownMenuLabel>
            {apps.map((app) => (
              <DropdownMenuItem key={app.code} onClick={() => setActiveApp(app.code)} className="gap-2 p-2">
                {app.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
